<template>
    <div>
        <Title>设计修改通知单</Title>
        <div class="panel">
            <div class="label">项目名称</div>
            <div class="value3">{{ extra.projectName }}</div>

            <div class="label">设计编号</div>
            <div class="value1">{{ extra.designNo }}</div>
            <div class="label">序号</div>
            <div class="value2">{{ extra.serialNo }}</div>

            <div class="label">专业</div>
            <div class="value1"><DataDictFinder dictType="cosys.major" :dictValue="extra.majorCode" /></div>
            <div class="label">签署人</div>
            <div class="value2">{{ extra.signerNames }}</div>

            <div class="label">变更原因</div>
            <div class="value3">{{ extra.changeReason }}</div>

            <div class="label">变更内容</div>
            <div class="value3">{{ extra.changeContent }}</div>

            <div class="label">设计成果</div>
            <div class="value3">
                <template v-if="designResultList.length">
                    <div v-for="(result, rIndex) in designResultList" :key="rIndex" style="margin-bottom: 8px;">
                        <div style="font-weight: 500; margin-bottom: 4px;">{{ result.resultName }}</div>
                        <div v-for="(item, aIndex) in result.attachmentList" :key="aIndex" style="padding-left: 12px;">
                            <a :href="item.url" target="_blank" @click.prevent="handleFileClick($event, item.url, item.name)">{{ item.name }}</a>
                        </div>
                        <div v-if="!result.attachmentList.length" style="padding-left: 12px; color: #999;">-</div>
                    </div>
                </template>
                <template v-else>
                    <div style="color: #999;">-</div>
                </template>
            </div>

            <div class="label" v-if="attachmentList.length">附件</div>
            <div class="value3" v-if="attachmentList.length">
                <div v-for="(item, index) in attachmentList" :key="index">
                    <a :href="item.url" target="_blank" @click.prevent="handleFileClick($event, item.url, item.name)">{{ item.name }}</a>
                </div>
            </div>
        </div>
        <Padding />
    </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "../Title";
export default {
    components: {
        Title,
    },
    computed: {
        ...mapState("approval", ["detail"]),
        extra() {
            return this.detail.extra ? this.detail.extra : {};
        },
        designResultList() {
            const results = this.extra.designResults;
            if (!results || !Array.isArray(results)) return [];
            return results.map(r => ({
                resultName: r.resultName || '',
                attachmentList: this.parseAttachments(r.attachment)
            }));
        },
        attachmentList() {
            if (!this.extra.attachment) return [];
            return this.extra.attachment.split(",").filter(Boolean).map(url => {
                let name;
                try {
                    name = decodeURIComponent(this.$getFileName(url));
                } catch (e) {
                    name = this.$getFileName(url);
                }
                return { url, name };
            });
        },
    },
    methods: {
        parseAttachments(attachment) {
            if (!attachment) return [];
            if (Array.isArray(attachment)) {
                return attachment.map(item => {
                    const url = item.completePath || item.id || item.url || '';
                    let name = item.name || '';
                    if (!name) {
                        try {
                            name = decodeURIComponent(this.$getFileName(url));
                        } catch (e) {
                            name = this.$getFileName(url);
                        }
                    }
                    return { url, name };
                });
            }
            if (typeof attachment === 'string') {
                try {
                    const parsed = JSON.parse(attachment);
                    if (Array.isArray(parsed)) {
                        return parsed.map(item => {
                            const url = item.completePath || item.id || item.url || '';
                            const name = item.name || '';
                            return { url, name };
                        });
                    }
                } catch (e) {
                    return attachment.split(',').filter(Boolean).map(url => {
                        let name;
                        try {
                            name = decodeURIComponent(this.$getFileName(url));
                        } catch (e) {
                            name = this.$getFileName(url);
                        }
                        return { url, name };
                    });
                }
            }
            return [];
        },
        isPdfFile(filename) {
            return filename && filename.toLowerCase().endsWith('.pdf');
        },
        previewPdf(url, filename) {
            const routeUrl = this.$router.resolve({
                path: '/pdf-preview',
                query: { url, title: filename || 'PDF预览' }
            }).href;
            window.open(routeUrl, '_blank');
        },
        deepDecodeURIComponent(str) {
            // 仅当结果中仍含 %25（编码的百分号）时才继续解码：
            // %25 是"还有一层编码未解"的唯一信号；没有 %25 时再解码会破坏
            // URL 中合法的编码字符（如文件名的 %2B、OSS 签名参数的 %2F），导致下载/查看链接失效
            let decoded = str;
            while (decoded.includes('%25')) {
                const prev = decoded;
                try {
                    decoded = decodeURIComponent(decoded);
                } catch (e) {
                    break;
                }
                if (decoded === prev) break;
            }
            return decoded;
        },
        handleFileClick(event, url, filename) {
            event.preventDefault();
            const decodedUrl = this.deepDecodeURIComponent(url);
            if (this.isPdfFile(filename)) {
                this.previewPdf(decodedUrl, filename);
            } else {
                const a = document.createElement('a');
                a.href = decodedUrl;
                a.download = filename || '';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        },
    },
};
</script>

<style lang="less" scoped>
.panel {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid #e8e8e8;

    & > div {
        padding: 8px;
        border-bottom: 1px solid #e8e8e8;
    }

    .label {
        background-color: #fafafa;
        border-right: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
    }

    .value1 {
        grid-column-start: 2;
        grid-column-end: 4;
    }

    .value2 {
        grid-column-start: 5;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value3 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }
}
</style>
